import { render, staticRenderFns } from "./OrderHistoryBox.vue?vue&type=template&id=40ec650c&scoped=true"
import script from "./OrderHistoryBox.vue?vue&type=script&lang=js"
export * from "./OrderHistoryBox.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryBox.vue?vue&type=style&index=0&id=40ec650c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec650c",
  null
  
)

export default component.exports